module.exports = __webpack_public_path__ + "static/media/my-account.8ff31efa.svg";